import {
  Box,
  Button,
  Card,
  CardHeader,
  Typography,
  useTheme,
} from '@mui/material';

import { tPortalLib } from '../../locales';
import { PortalTheme } from '../../theme';
import { HomeLoginSignupText } from './home-login-signup-text.component';

export interface HomeLoginCardProps {
  title: string;
  description: string;
  onClickLogin: () => void;
  onClickSignUp: () => void;
  loginHref: string;
  signUpHref: string;
  signUpEnabled?: boolean;
  loginLabel?: string;
  signUpText?: string;
  signUpLink?: string;
}

export const HomeLoginCard = (props: HomeLoginCardProps) => {
  const theme = useTheme<PortalTheme>();

  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: `${theme.shape.borderRadius}px`,
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.boxShadow,
        backgroundColor: theme.palette.background.paper,
        py: 4,
        px: 2,
      }}
    >
      <CardHeader
        sx={{
          p: 0,
          textAlign: 'center',
        }}
        title={<Typography variant="h4">{props.title}</Typography>}
        subheader={
          <Typography variant="body2" color="textSecondary">
            {props.description}
          </Typography>
        }
      />

      <Box
        sx={{
          pt: 3,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        }}
      >
        <Button
          fullWidth
          size="large"
          color="primary"
          variant="contained"
          aria-label="login_button"
          component="a"
          href={props.loginHref}
          onClick={(e) => {
            e.preventDefault();
            props.onClickLogin();
          }}
        >
          {props.loginLabel || tPortalLib.login.logIn()}
        </Button>

        {props.signUpEnabled && (
          <HomeLoginSignupText
            href={props.signUpHref}
            onClickSignUp={props.onClickSignUp}
            text={props.signUpText}
            linkText={props.signUpLink}
          />
        )}
      </Box>
    </Card>
  );
};
